import EventEmitter from 'eventemitter3';
import React, { createContext } from 'react';

import { useVar } from '../hooks/useVar';

export const EventEmitterContext = createContext<EventEmitter | null>(
  null,
);

interface IEventEmitterProviderProps {
  children: React.ReactNode;
}

export function EventEmitterProvider({
  children,
}: IEventEmitterProviderProps) {
  const eventEmitter = useVar(new EventEmitter());

  return (
    <EventEmitterContext.Provider value={eventEmitter}>
      {children}
    </EventEmitterContext.Provider>
  );
}
